import { useState } from "react";
import { GraduationCap, Loader2, X } from "lucide-react";
import { toast } from "sonner";

const input = "w-full rounded-xl border border-amber-800/20 bg-white px-4 py-3 text-sm outline-none focus:border-amber-deep";

export default function ReassignSchoolModal({ schools, currentSchoolId, askCode, onSubmit, onClose }) {
  const [f, setF] = useState({ school_id: currentSchoolId || schools[0]?.school_id || "", access_code: "", student_first: "", student_last: "", student_class: "" });
  const [busy, setBusy] = useState(false);
  const up = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const needCode = askCode && f.school_id !== currentSchoolId;

  const submit = async () => {
    if (!f.school_id) return toast.error("Choisissez une école");
    if (needCode && !f.access_code.trim()) return toast.error("Saisissez le code d'accès de l'école");
    if (!f.student_first.trim() || !f.student_last.trim() || !f.student_class.trim()) return toast.error("Indiquez le prénom, le nom et la classe de l'élève");
    setBusy(true);
    try { await onSubmit(f); } finally { setBusy(false); }
  };

  return (
    <div data-testid="reassign-modal" className="fixed inset-0 z-[70] flex items-center justify-center bg-bark/60 p-4 backdrop-blur-sm" onClick={onClose}>
      <div className="relative w-full max-w-md rounded-3xl bg-white p-6 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <button data-testid="reassign-close" onClick={onClose} aria-label="Fermer" className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-sand text-bark hover:bg-amber-800/10"><X size={18} /></button>
        <p className="flex items-center gap-2 font-serif text-2xl font-semibold text-bark"><GraduationCap size={22} className="text-amber-deep" /> Réassigner à une école</p>
        <p className="mt-1 text-sm text-bark-soft">La commande sera remise à l'école choisie au lieu d'être expédiée.</p>
        <div className="mt-5 space-y-3">
          <select data-testid="reassign-school" value={f.school_id} onChange={up("school_id")} className={input}>
            {schools.length === 0 && <option value="">Aucune école disponible</option>}
            {schools.map((s) => <option key={s.school_id} value={s.school_id}>{s.name}{s.city ? ` — ${s.city}` : ""}</option>)}
          </select>
          {needCode && <input data-testid="reassign-code" value={f.access_code} onChange={up("access_code")} placeholder="Code d'accès de l'école *" className={input} />}
          <div className="grid grid-cols-2 gap-3">
            <input data-testid="reassign-student-first" value={f.student_first} onChange={up("student_first")} placeholder="Prénom de l'élève *" className={input} />
            <input data-testid="reassign-student-last" value={f.student_last} onChange={up("student_last")} placeholder="Nom de l'élève *" className={input} />
          </div>
          <input data-testid="reassign-student-class" value={f.student_class} onChange={up("student_class")} placeholder="Classe de l'élève * (ex. CE2)" className={input} />
          <button data-testid="reassign-submit" onClick={submit} disabled={busy} className="flex w-full items-center justify-center gap-2 rounded-full bg-amber-deep py-3 text-sm font-semibold text-white hover:bg-amber-deep/90 disabled:opacity-60">
            {busy && <Loader2 size={16} className="animate-spin" />} Réassigner la commande
          </button>
        </div>
      </div>
    </div>
  );
}
